const yesNoBooleanMap = input => {
  switch (input?.toLowerCase()) {
    case 'yes':
      return true;
    case 'no':
      return false;
    default:
      return input;
  }
};

export const filterYesNoFromBoolean = (rows, id, filterValue) =>
  rows.filter(row => row.values[id] === yesNoBooleanMap(filterValue));

// need this to remove custom filter from table filters when removed on UI
filterYesNoFromBoolean.autoRemove = value => !value;
